import React from 'react'
import {createIcon} from '@chakra-ui/react'

// The partner to SensitiveIcon, for when the value it hides is on show: the
// same eye, struck through.
export const SensitiveOffIcon = createIcon({
  displayName: 'SensitiveOffIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M17.94 17.94A10.07 10.07 0 0 1 12 20C5 20 1 12 1 12A18.45 18.45 0 0 1 5.06 6.06M9.9 4.24A9.12 9.12 0 0 1 12 4C19 4 23 12 23 12A18.5 18.5 0 0 1 21.17 14.83M14.12 14.12A3 3 0 1 1 9.88 9.88"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1L23 23"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
})
